<template>
  <div style="text-align: right; margin-top: 6px">
    <el-pagination
      :background="background"
      :layout="layout"
      :page-size="pageSize"
      small
      :total="total"
      @current-change="pageChange"
        @size-change="sizeChange"
      :current-page.sync="myCurrentPage"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    layout: {
      type: String,
      default: "total,prev,pager,next,sizes",
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    background: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      myCurrentPage: 1,
    };
  },
  watch: {
    currentPage() {
      this.myCurrentPage = this.currentPage;
    },
  },
  methods: {
    sizeChange(val) {
      this.$emit("size-change", val);
    },
    pageChange(val) {
      this.$emit("current-change", val);
    },
  },
};
</script>
